var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './Badge.scss';
function Badge(_a) {
    var fill = _a.fill, text = _a.text, color = _a.color, type = _a.type;
    return (_jsx("div", __assign({ className: "Badge Badge--" + type + " background--" + fill + "-" + color }, { children: text }), void 0));
}
export default Badge;
